function hotels(state = [], action) {
    switch (action.type) {
        case 'HOTELS/SET':
            return action.hotels;
        case 'HOTELS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default hotels;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/hotels.js